import { TableCell } from '~/UIKit';
import React from 'react';
import { getInitials } from '../../../Helpers/String.helper';
import { CellProps } from './CellProps';
import { makeStyles } from '~/UIKit/Style';

/**
 * Each cell, gets the data through a value object.
 * The table will automatically pass the parsed data to
 * the cell. In this case the value object will consist of
 * @member {string} imageUrl
 * @member {string} color
 * @member {string} firstname
 * @member {string} lastname
 */
export interface ImageCellProps extends CellProps {
  value: {
    imageUrl: string;
    color: string;
    firstname: string;
    lastname: string;
  };
}

const useStyles = (imageUrl: string, color: string) =>
  makeStyles(() => ({
    image: {
      borderRadius: '50%',
      backgroundImage: imageUrl,
      backgroundColor: color,
      width: '30px',
      height: '30px',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      lineHeight: 2,
    },
  }));

const ImageCell = ({ value, className }: ImageCellProps) => {
  // Pass down the URL and Color, the URL is used as a background image
  const { classes } = useStyles(value.imageUrl, value.color)();
  return (
    <TableCell className={className}>
      <div className={classes.image}>
        {!value.imageUrl && <span>{getInitials(value.firstname, value.lastname)}</span>}
      </div>
    </TableCell>
  );
};

export default ImageCell;
